import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TempleProfile } from '../model/temple-profile';
@Injectable()
export class TempleProfileService {


  constructor(private http: HttpClient) { }
  updateProfile(object,id): Observable<TempleProfile> {
    return this.http.put<TempleProfile>(`temple`, object);
  }
  addProfile(object,id): Observable<TempleProfile> {
    return this.http.post<TempleProfile>(`temple`, object);
  }
  getTempleDetails(id): Observable<any> {
    return this.http.get<any>(`temple/profile`);
  }
}
